// A query string, spelled by hand. Pure, and shared by every href builder that
// has to keep a lens key intact (lib/scope-url.ts, lib/videos-url.ts, lib/lens-url.ts).
//
// ⚠️ NEVER `URLSearchParams.toString()` for an address the app writes. It
// escapes `:` as `%3A`, and a brand lens key carries one (`?as=brand:fernhill`).
// `:` is legal in a query,
// so it is left as it is, and one address has one spelling — which is what lets
// a builder compare the address it would write with the one already in the bar.

/** One query name or value, escaped — except `:`. */
export function enc(v: string): string {
  return encodeURIComponent(v).replace(/%3A/gi, ":");
}

/** `?a=1&b=2`, in the order given, or "" for no pairs. */
export function query(pairs: Iterable<[string, string]>): string {
  const parts: string[] = [];
  for (const [k, v] of pairs) parts.push(`${enc(k)}=${enc(v)}`);
  return parts.length ? `?${parts.join("&")}` : "";
}
